import { API_ENDPOINTS } from '../constants/endpoints';
import { get, post, put } from '../utils/api.utils';
import StorageService, { STORAGE_KEYS } from '../utils/storage.util';
import { UsageResponse } from '../types/usage';
import { decodeMetadataToken } from '../utils/token.utils';

class UsageService {
  public static async fetchUsage(): Promise<UsageResponse> {
    try {
      const accessToken = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      const metadata = decodeMetadataToken();
      const subscriptionId = metadata?.companies?.[0]?.subscription.id
      const customerId = metadata?.companies?.[0]?.id
    // const subscriptionId = 'usage-test-sub-1'
      const response = await get<UsageResponse>(
        API_ENDPOINTS.USAGE.FETCH + `${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
      
      return response;
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw new Error('Unauthorized. Please login again');
      }      
      throw new Error('An error occurred while updating profile. Please try again');
    }
  }
}

export default UsageService;